var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYtubenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed472e;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.14,15.85c-.6-1.07-1.25-1.27-2.58-1.34s-4.67-.13-7.56-.13-6.23,0-7.56.12-2,.28-2.59,1.35-.94,2.91-.94,6.15h0c0,3.22.32,5.08.94,6.13s1.26,1.27,2.59,1.36,4.67.12,7.56.12,6.23,0,7.56-.12,2-.28,2.59-1.35.94-2.92.94-6.14h0C33.09,18.76,32.77,16.92,32.14,15.85ZM19.23,26.16V17.84L26.16,22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtubenew);
export default __webpack_public_path__ + "static/media/ytubenew.93b6cad4ff80f740eb59e91ed1fd0ce1.svg";
export { ForwardRef as ReactComponent };